import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';
import Dropzone from 'react-dropzone';
import Clickable from '../../../../components/clickable/Clickable';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import styles from '../steps.module.scss';
import PulpoField from '../../../../pulpo_visualizer/fields';
import CustomField from '../../../../components/customFields/customField';
import LocationFields from '../../components/LocationFields';
import TooltipWithHeading from '../../../../components/helpToolTip/ToolTip';
import { imageFileExtensions, checkMultiFilesValidation, videoFileExtensions, docFileExtensions } from '../../../../utils/helpers';

class Step2 extends Component {
  handleDrop = (dropped) => {
    if (!checkMultiFilesValidation(dropped, `${imageFileExtensions} , ${docFileExtensions} , ${videoFileExtensions}`)) return;
    const { onInfoChange, hazardInfo, handleFileSizeValidation } = this.props;
    handleFileSizeValidation(false);
    const noError = dropped.every(i => i?.size< 100000000);
    if (!noError) {
      handleFileSizeValidation(true);
      return;
    }
    onInfoChange(
      'attachments',
      [...hazardInfo.attachments, ...dropped]
    );
  };

  handleRemoveImage = (r) => {
    const { onInfoChange, hazardInfo } = this.props;
    const res = hazardInfo.attachments.filter(e => e !== r);
    onInfoChange('attachments', res);
    const existingRemoved = hazardInfo?.removedAttachments || [];
    if (r.id) {
      onInfoChange(
        'removedAttachments',
        [...existingRemoved, r.id]
      );
    }
  };

  render() {
    const {
      hazardInfo,
      handleAnswerChanged,
      handleFieldErrorChanged,
      showFormErrors,
      answers,
      onInfoChange,
      requiredMap,
      dataSchema,
      map,
      orderField,
      defaultFieldSchema,
      nomenclature,
      locationList,
      category,
      priority,
      categorySetting,
      singleLocation,
      publicFormSettings,
      fileSizeError,
      datasources,
      selectedLang,
      intl,
      sms_form,
      errorListMCG
    } = this.props;

    const getDescription = () => ((selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.description)
    ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.description
    : `${defaultFieldSchema?.[orderField]?.description || ''}`);

    const getTitle = defaultTitle => ((selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name)
                ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name : `${defaultFieldSchema?.[orderField]?.title || defaultTitle}`);
    const enableThirdLevel = sms_form?.public_form_settings?.enable_third_level;
    return (
      <>
        {orderField === 'default_step2_header' && !defaultFieldSchema?.[orderField]?.isDisabled && (
          <div className={`${styles.title} d-flex`} style={{ borderBottom: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE' }}>
            {((selectedLang || defaultFieldSchema?.[orderField]?.title) && defaultFieldSchema?.[orderField])
              ? <h5>
                  {defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name || defaultFieldSchema?.[orderField]?.title}
                </h5>
              : <FormattedMessage
                tagName="h5"
                id="sms.details.custom"
                values={{
                  title: intl.formatMessage({
                    id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
                    defaultMessage: nomenclature?.hazard_title
                  })
                }}
                defaultMessage={`${intl.formatMessage({
                  id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
                  defaultMessage: nomenclature?.hazard_title
                })} Details`}
              />}
            {defaultFieldSchema?.[orderField]?.description?.length > 0 && (
              <TooltipWithHeading
                title="Help Text"
                toolTip={`form.setting.newfield.helptext.${defaultFieldSchema?.[orderField]?.description}`}
                text={getDescription()}
                values={getDescription()}
                iconStyles={styles.helpTooltip}
              />
            )}
          </div>
        )}
        {orderField === 'default_title' && (
          <>
            <PulpoField
              key="title"
              id="title"
              type="string"
              className={`${styles.fullInput} ${styles.noMarginLeft}`}
              translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.title'}
              title={getTitle('Title')}
              description={getDescription()}
              handleValueChange={(a, b) => onInfoChange(b, a)}
              answer={hazardInfo?.title}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              fromSMS
            />
          </>
        )}
        {!categorySetting && (
          <>
            {orderField === 'default_category' && (
              <PulpoField
                key="category"
                id="category"
                type="multiselect"
                widget={{ type: 'dropdown' }}
                translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.category'}
                title={getTitle('Category')}
                isRequired
                description={getDescription()}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                values={
                  _.sortBy(category
                    ? category.map(e => ({
                      key: e.name,
                      value: selectedLang && selectedLang!==''
                      && e?.meta_data?.[selectedLang] ? e?.meta_data?.[selectedLang] : e.name
                    }))
                    : [], [eachCategory => eachCategory.value?.toLowerCase()])}
                answer={hazardInfo.category}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
            {orderField === 'default_sub_category' && (category
              ?.filter(item => hazardInfo?.category?.includes(item?.name)) // Match multiple categories
              ?.map(sub => sub?.sub_category) // Get sub_category arrays
              .flat() // Flatten nested arrays
              .map(e => e?.name) ?? [])?.length > 0 && (
              <PulpoField
                key="subCategory"
                id="sub_category"
                type="multiselect"
                widget={{ type: 'dropdown' }}
                translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.subCategory'}
                title={(selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name)
                  ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name
                  : `${defaultFieldSchema?.[orderField]?.title || 'Sub Category 1'}`}
                isRequired
                description={getDescription()}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                values={_.sortBy((category
                  ?.filter(item => hazardInfo?.category?.includes(item?.name)) // Match multiple categories
                  ?.map(sub => sub?.sub_category) // Get sub_category arrays
                  .flat() // Flatten nested arrays
                  .map(e => e?.name) ?? [])?.map(e => ({
                      key: e,
                    value: selectedLang && selectedLang!==''
                    && e?.meta_data?.[selectedLang] ? e?.meta_data?.[selectedLang] : e
                  })), [eachCategory => eachCategory.value?.toLowerCase()])}
                answer={hazardInfo.sub_category}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
            {enableThirdLevel
            && orderField === 'default_sub_category_2'&& (category
              ?.filter(cat => hazardInfo?.category?.includes(cat?.name))
              ?.flatMap(cat => cat?.sub_category || [])?.filter(sub => hazardInfo?.sub_category?.includes(sub?.name))
              ?.flatMap(sub => sub?.sub_category_2 || [])
              ?.map(e => e?.name) ?? []).length > 0 && (
              <PulpoField
                key="subCategory2"
                id="sub_category_2"
                type="multiselect"
                widget={{ type: 'dropdown' }}
                translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.subCategory2'}
                title={(selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name)
                  ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name
                  : `${defaultFieldSchema?.[orderField]?.title || 'Sub Category 2'}`}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                description={getDescription()}
                isRequired
                values={_.sortBy((category
                  ?.filter(cat => hazardInfo?.category?.includes(cat?.name))
                  ?.flatMap(cat => cat?.sub_category || [])?.filter(sub => hazardInfo?.sub_category?.includes(sub?.name))
                  ?.flatMap(sub => sub?.sub_category_2 || [])
                  ?.map(e => ({
                      key: e.name,
                      value:
                      selectedLang && selectedLang !== '' && e?.meta_data?.[selectedLang]
                      ? e?.meta_data?.[selectedLang]: e.name
                    })) ?? []), [eachCategory => eachCategory.value?.toLowerCase()])}
                answer={hazardInfo.sub_category_2}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
            {orderField === 'default_priority' && (
              <PulpoField
                key="priority"
                id="priority"
                type="select"
                translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.priority'}
                title={getTitle('Priority')}
                isRequired
                description={getDescription()}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                values={priority?.map(e => ({
                    key: e.name,
                    value: selectedLang && selectedLang!==''
                    && e?.meta_data?.[selectedLang] ? e?.meta_data?.[selectedLang] : e.name
                  }))}
                answer={hazardInfo.priority}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                fromSMS
              />
            )}
          </>
        )}
        {orderField === 'default_description' && (
            <PulpoField
              key="description"
              id="description"
              type="string" isRequired
              className={`${styles.fullInput} ${styles.noMarginLeft}`}
              widget={{ type: 'textarea' }}
              translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.description'}
              title={getTitle('Description of Hazard')}
              description={getDescription()}
              handleValueChange={(a, b) => onInfoChange(b, a)}
              answer={hazardInfo.description}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              fromSMS
            />
        )}
        {orderField === 'default_location'
          && (
          <>
            {!!publicFormSettings?.global_locations && !!publicFormSettings?.enable_location_sms && (
              <LocationFields
                info={hazardInfo}
                locationList={locationList}
                onInfoChange={(a, b) => onInfoChange(a, b)}
                withoutDepartments
                locationKey="name"
                withFloorPlan
                icon={map?.nwo_icon}
                map={map}
                sms_form={sms_form}
                singleLocation={singleLocation}
                fromSMS
                title={getTitle('Locations')}
              />
            )}
            {(!publicFormSettings?.global_locations || !publicFormSettings?.enable_location_sms) && (
              <PulpoField
                key="location"
                id="location"
                type="location"
                map_style={map.map_style}
                mapbox_style={map?.mapbox_style || sms_form?.mapbox_style}
                className={`${styles.fullInput} ${styles.noMarginLeft}`}
                isRequired
                translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'workorder.create.location'}
                title={getTitle('Location')}
                description={getDescription()}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                answer={map.location}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={() => ({})}
                fromSMS
              />
            )}
          </>
        )}
        {!orderField.includes('default_') && (
            <CustomField
              handleAnswerChanged={handleAnswerChanged}
              handleFieldErrorChanged={handleFieldErrorChanged}
              answers={answers}
              showFormErrors={showFormErrors}
              requiredMap={requiredMap}
              fields={dataSchema}
              airport_data={map}
              forSmsPublic
              orderField={orderField}
              datasources={datasources}
              selectedLang={selectedLang}
              sms_form={sms_form}
              hazardInfo={hazardInfo}
              enableThirdLevel={enableThirdLevel}
              checkCategories
              errorListMCG={errorListMCG}
              isFromSms
            />
        )}
        {orderField === 'default_photos' && !defaultFieldSchema?.[orderField]?.isDisabled && (
          <div className={`${styles.fullInput} ${styles.noMarginLeft}`}>
            <FormattedMessageWithClass
              className={selectedLang === 'az' ? '' : styles.label}
              id={defaultFieldSchema?.[orderField] ? 'invalid' : 'workorder.create.photos'}
              defaultMessage={getTitle('Photos')}
            />
            {defaultFieldSchema?.[orderField]?.description?.length > 0 && (
              <TooltipWithHeading
                title="Help Text"
                toolTip={`form.setting.newfield.helptext.${defaultFieldSchema?.[orderField]?.description}`}
                text={getDescription()}
                values={getDescription()}
                iconStyles={styles.helpTooltip}
              />
            )}
            <Dropzone
              onDrop={this.handleDrop}
              disableClick
              className={styles.dropzone}
              accept={'image/*, video/*, .pdf, .doc, .docx'}
              style={{ border: selectedLang === 'az' ? '2px dashed #2e406b' : '2px dashed #E6EAEE' }}
            >
              {({ open }) => (
                  <p className={styles.browsetext}>
                    <FormattedMessage
                      id="airport.logo.text1"
                      defaultMessage="Drag an image here or"
                    />
                    <button type="button" onClick={() => open()}>
                      <FormattedMessage
                        id="airport.logo.button"
                        defaultMessage="browse"
                      />
                    </button>
                    <FormattedMessage
                      id="airport.logo.text2"
                      defaultMessage="for an image to upload."
                    />
                  </p>
              )}
            </Dropzone>
            {fileSizeError
            && <small style={{ color: 'red' }}>
                <FormattedMessage
                  id="file.size.validation.error"
                  defaultMessage="File size should be less than 100MB"
                />
               </small>}
            {hazardInfo.attachments.length > 0 && (
              <div className={styles.photos}>
                {hazardInfo.attachments.map(e => (
                  <div key={e.name} className={styles.wrapper}>
                    <Clickable onClick={() => this.handleRemoveImage(e)}>
                      &times;
                    </Clickable>
                    <img src={e.preview || e.url} alt={e.file_name || e.name} />
                  </div>
                ))}
              </div>
            )}
            {hazardInfo?.contact_info && (publicFormSettings?.enable_receive_updates_field ?? true) && (
              <div className={`${styles.title} ${styles.notification}`} style={{ color: selectedLang==='az' ? '#2e406b' : '' }}>
                <input
                  name="enable_notifications"
                  id="enable_notifications"
                  type="checkbox"
                  accept="image/*"
                  style={{ cursor: 'pointer' }}
                  onChange={() => onInfoChange('enable_notifications', !hazardInfo.enable_notifications)}
                    value
                    defaultChecked={hazardInfo.enable_notifications}
                />
                &nbsp;&nbsp;
                <FormattedMessage
                  id="sms.new.enable.notifications.title"
                  values={{ title: intl.formatMessage({ id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
                  defaultMessage: nomenclature?.hazard_title || 'Safety Hazard' }) }}
                  defaultMessage={`Would like to receive updates about the ${nomenclature?.hazard_title} ?`}
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

Step2.propTypes = {
  category: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  priority: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  hazardInfo: PropTypes.shape({}).isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool.isRequired
};

export default injectIntl(Step2);
